import { render } from "./ClanAvisos.vue?vue&type=template&id=9ba8b670&scoped=true"
import script from "./ClanAvisos.vue?vue&type=script&lang=js"
export * from "./ClanAvisos.vue?vue&type=script&lang=js"

import "./ClanAvisos.vue?vue&type=style&index=0&id=9ba8b670&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9ba8b670"]])

export default __exports__